module.exports = __webpack_public_path__ + "89cd003f5ea0ab70aea53a01083d581b.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/raw-key-art-1024.jpg
// module id = 518
// module chunks = 0